import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { SalesFooter } from '../components/SalesFooter';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0f1b2d]" data-id="element-151">
      <HeroSection data-id="element-152" />
      <OpeningHook data-id="element-153" />
      <ProblemSection data-id="element-154" />
      <FailedSolutions data-id="element-155" />
      <MechanismSection data-id="element-156" />
      <WhatYouGet data-id="element-157" />
      <AudienceSection data-id="element-158" />
      <HowItWorks data-id="element-159" />
      <ProofSection data-id="element-160" />
      <FAQSection data-id="element-161" />
      <OfferSection data-id="element-162" />
      <SalesFooter data-id="element-163" />
    </div>;
}